// actions
import { DBDrop, LocalClear } from '@weblite/persist'
import { setTwaAuthToken } from '$logic/twaCommunication'
import { dispatchSetConnectionStatus } from '$comp/main/root.action'
import { DB_NAME } from '$setup/persist'
import { fullReload } from '$func/fullReload'
import { SESSION_STORAGE_KEYS } from '$logic/client-device/types'
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'

export const restoreSessionStorageOnSignOut = () => {
  // retain `twaWsUrl` so that after login, client can send the new token to TWA
  const wsUrl = sessionStorageGetItem(SESSION_STORAGE_KEYS.TWA_WS_URL)
  // retain `contact_perm` so that after login, client can sync contacts to TWA
  const contactPerm = sessionStorageGetItem(SESSION_STORAGE_KEYS.CONTACT_PERM)
  // retain `isTwa` so that after login, client can work with TWA
  const isTwa = sessionStorageGetItem(SESSION_STORAGE_KEYS.IS_TWA)
  sessionStorage.clear()
  sessionStorageSetItem(SESSION_STORAGE_KEYS.TWA_WS_URL, wsUrl)
  sessionStorageSetItem(SESSION_STORAGE_KEYS.CONTACT_PERM, contactPerm)
  sessionStorageSetItem(SESSION_STORAGE_KEYS.IS_TWA, isTwa)
}

export default () => {
  dispatchSetConnectionStatus('signing out')
  LocalClear()
  restoreSessionStorageOnSignOut()
  setTwaAuthToken(null)

  DBDrop(DB_NAME).then(fullReload)
}
